import React, { useContext, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import Modal from 'components/Modal';
import { PriceTagProps, RespTags } from 'types/PriceTagProps';
import SimpleTextArea from 'components/SimpleTextArea';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';
import SearchByPriceTag from 'components/SearchByPriceTag';
import InputColor from 'components/InputColor';
import InputImg from 'components/InputImg';
import SelectInput from 'components/SelectInput';
import { findOptionOnListById } from 'utils/functions';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { positions } from './options';
import SimpleInput from 'components/SimpleInput';
import { createTag, editTag } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { getTags } from 'pages/PriceTag/reqs';

const initialState: PriceTagProps = {
	background_color: '#000',
	color: '#fff',
	created_at: '',
	file: null,
	file_id: null,
	font_size: null,
	id: '',
	location: null,
	position: 'bottom-right',
	priority: 1,
	text: '',
	updated_at: '',
	visible: true,
	vtex_cluster_id: '',
	vtex_cluster_name: ''
};

interface FormPriceTagProps {
	datalistTags: RespTags;
	setDataListTags: React.Dispatch<React.SetStateAction<RespTags>>;
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	tagToEdit: PriceTagProps | null;
	setTagToEdit: React.Dispatch<React.SetStateAction<PriceTagProps | null>>;
}

export default function FormPriceTag({
	isOpenForm,
	setIsOpenForm,
	tagToEdit,
	datalistTags,
	setDataListTags,
	setTagToEdit
}: FormPriceTagProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = useState<PriceTagProps>(initialState);

	function resetStatesComp() {
		setIsOpenForm(false);
		setDataForm(initialState);
		setTagToEdit(null);
	}

	async function saveTag() {
		if (dataForm.vtex_cluster_name === '' || dataForm.vtex_cluster_id === '') {
			handleNotify('Selecione alguma coleção', 'error');
			return;
		}

		setMessage(tagToEdit === null ? 'Salvando etiqueta' : 'Editando etiqueta');
		setIsOpenLoad(true);

		const isSuccess =
			tagToEdit === null
				? await createTag(dataForm, handleNotify)
				: await editTag(dataForm, handleNotify);

		if (isSuccess) {
			const { data, isSuccess } = await getTags(
				datalistTags.page,
				handleNotify
			);

			if (isSuccess && data) {
				setDataListTags(data);
			}
			resetStatesComp();
		}

		setIsOpenLoad(false);
	}

	//se estiver editando aqui salvar o valor
	useLayoutEffect(() => {
		setTimeout(() => {
			if (tagToEdit !== null) {
				setDataForm(tagToEdit);
			}
		}, 100);
	}, []);

	//se deletar a imagem, eu volto o valor do file para null
	useLayoutEffect(() => {
		if (typeof dataForm.file === 'string') {
			setDataForm((obj) => ({ ...obj, file: null, file_id: null }));
		}
	}, [dataForm.file]);

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetStatesComp();
			}}
			title={'Etiquetas promocionais'}
			buttonClose={false}
		>
			<S.container>
				<S.inptus>
					<SimpleTextArea
						disable={dataForm.file === null ? false : true}
						title={'Descrição'}
						rows={6}
						colorFont={color.interface.lightGray}
						labelColor={color.interface.lightGray}
						borderColor={color.interface.lightGray2}
						textArea={dataForm.text}
						getValue={(value: string) => {
							setDataForm((obj) => ({ ...obj, text: value }));
						}}
					/>

					<S.twoItens>
						<SearchByPriceTag dataForm={dataForm} setDataForm={setDataForm} />
						<SelectInput
							list={positions}
							getValue={(value: SelectInputItemProps | '') => {
								setDataForm((obj) => ({
									...obj,
									position: value === '' ? value : (value?.id as string)
								}));
							}}
							initialValue={
								dataForm.position === ''
									? positions[0]
									: findOptionOnListById(dataForm.position || '', positions)
							}
							label="Posição"
						/>
					</S.twoItens>

					<S.threeItens>
						<SimpleInput
							typeInput="number"
							paddingInLineEnd
							initialValue={dataForm.priority}
							label="Prioridade"
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									priority: parseInt(value)
								}));
							}}
						/>
						<InputColor
							rgbOrExadecimal={false}
							label="Cor do texto"
							value={dataForm.color}
							setValue={(value: string) => {
								setDataForm((obj) => ({ ...obj, color: value }));
							}}
						/>
						<InputColor
							rgbOrExadecimal={false}
							label="Cor do fundo"
							value={dataForm.background_color}
							setValue={(value: string) => {
								setDataForm((obj) => ({ ...obj, background_color: value }));
							}}
						/>
					</S.threeItens>

					<InputImg
						diseable={dataForm.text === '' ? false : true}
						label="Ícone"
						idImagem="tag"
						btnDeleteImage
						initialImage={dataForm?.file?.url || ''}
						getImage={(value: any) => {
							setDataForm((obj) => ({
								...obj,
								file: value,
								file_id: value.id
							}));
						}}
					/>
				</S.inptus>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetStatesComp();
						}}
					>
						{t('cancel')}
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={() => {
							saveTag();
						}}
					>
						{t('save')}
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
